/** @file Left/right name pairing: `upper-arm-L` ↔ `upper-arm-R`; null when the name has no side suffix. */

/** Returns the counterpart name for a `-L`/`-R` suffixed name (case-sensitive), else null. */
export function mirrorName(name: string): string | null {
  if (name.endsWith('-L')) return `${name.slice(0, -2)}-R`;
  if (name.endsWith('-R')) return `${name.slice(0, -2)}-L`;
  return null;
}
